module.exports = __webpack_public_path__ + "img/2.c5c9a9d4.png";